const BOOKING_PLATFORM_MARKERS = [
  'agoda',
  'airbnb',
  'atraveo',
  'belvilla',
  'bestfewo',
  'booking',
  'casamundo',
  'dancenter',
  'destinationsolutions',
  'edomizil',
  'expedia',
  'ferienhausmiete',
  'fewochannelmanager',
  'fewodirekt',
  'holidaycheck',
  'holidu',
  'homeaway',
  'hometogo',
  'interchalet',
  'interhome',
  'novasol',
  'roompot',
  'secra',
  'traumferienwohnungen',
  'travanto',
  'tuivillas',
  'vrbo',
] as const;

export function isBookingPlatform(value: string | null | undefined): boolean {
  if (!value) return false;
  const normalized = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
  return BOOKING_PLATFORM_MARKERS.some(marker => normalized.includes(marker));
}

export function landlordPrefillName(
  hostName: string | null | undefined,
  offerProvider: string | null | undefined,
): string | null {
  if (hostName && !isBookingPlatform(hostName)) return hostName;
  if (offerProvider && !isBookingPlatform(offerProvider)) return offerProvider;
  return null;
}